import React, { useMemo, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GoogleMapsProvider from "../GoogleMapsProvider";
import GetStartedModal from "../getstarted";
import LetsConnectModal from "../LetsConnectModal";
import { cleanupModalScrollLock } from "../../utils/modalScrollCleanup";
import LandingNav from "./LandingNav";
import LandingConnectFab from "./LandingConnectFab";
import LandingFooter from "./LandingFooter";
import LandingCustomCursor from "./LandingCustomCursor";
import { LandingModalContext } from "./landingModalContext";
import "../../screens/Home/landing.scss";

const LandingLayout = ({ children, showModal, setCloseShowModal }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showType, setShowType] = useState(null);
  const [letsconnect, setLetsconnect] = useState(false);

  const handleCloseGetStarted = useCallback(() => {
    setShow(false);
    if (location.pathname === "/rapid-estimates") {
      navigate("/", { replace: true });
    }
    window.setTimeout(cleanupModalScrollLock, 350);
  }, [location.pathname, navigate]);
  const openLetsConnect = useCallback(() => {
    setShow(false);
    setLetsconnect(true);
  }, []);
  const closeLetsConnect = useCallback(() => {
    setLetsconnect(false);
    window.setTimeout(cleanupModalScrollLock, 350);
  }, []);

  const modalApi = useMemo(
    () => ({
      openGetStarted: () => {
        setLetsconnect(false);
        setShowType("");
        setShow(true);
      },
      openKitchen: () => {
        setShowType("Kitchen");
        setShow(true);
      },
      openBathroom: () => {
        setShowType("Bathroom");
        setShow(true);
      },
      openLetsConnect,
    }),
    [openLetsConnect]
  );

  return (
    <LandingModalContext.Provider value={modalApi}>
      <div className="refined-landing">
        <LandingCustomCursor />
        <LandingNav />
        <LandingConnectFab />
        {children}
        <LandingFooter />
        <GoogleMapsProvider>
          <GetStartedModal
            show={show}
            showType={showType}
            handleClose={handleCloseGetStarted}
            showModal={showModal}
            setCloseShowModal={setCloseShowModal}
          />
          <LetsConnectModal letsconnect={letsconnect} onClose={closeLetsConnect} />
        </GoogleMapsProvider>
      </div>
    </LandingModalContext.Provider>
  );
};

export default LandingLayout;
